import { Link, Route, useNavigate } from "react-router-dom";
import AydınlatmaMetni from "./AydınlatmaMetni";
import { useDispatch } from "react-redux";

export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer className=" bg-purple-600 text-white">
      <div
        className="mx-auto max-w-7xl px-4 py-10"
        style={{
          fontFamily: "Inter, system-ui, -apple-system, sans-serif ",
        }}
      >
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {/* Uygulama Bilgisi */}
          <div>
            <p className="text-lg font-semibold">hakkımızda</p>
            <hr className="border-b  border-yellow-500" />
            <p
              className="text-md mt-2 hover:text-yellow-500 cursor-pointer"
              onClick={() => navigate("/about")}
            >
              about(hakkmızda)
            </p>
            <p className="mt-2 text-sm ">
              İlkokul öğrencileri için güvenli, eğlenceli ve etkili dijital
              eğitim platformu.
            </p>
            <div></div>
          </div>

          {/* Hukuki Linkler */}
          <div>
            <h4 className="text-lg font-semibold ">Yasal</h4>
            <hr className="border-b  border-yellow-500" />
            <ul className="mt-3 space-y-2 text-sm cursor-pointer    ">
              <li
                onClick={() => navigate("/kvkk")}
                className="hover:text-yellow-400 "
              >
                KVKK Aydınlatma Metni
              </li>
              <li
                className="hover:text-yellow-400 "
                onClick={() => navigate("/gizlilik")}
              >
                Gizlilik Politikası
              </li>
              <li
                className="hover:text-yellow-400 "
                onClick={() => navigate("/kullanim-sartlari")}
              >
                Kullanım Şartları
              </li>
              <li
                className="hover:text-yellow-400 "
                onClick={() => navigate("/mesafeli-satis")}
              >
                Mesafeli Satış Sözleşmesi
              </li>
              <li
                className="hover:text-yellow-400  "
                onClick={() => navigate("/iade")}
              >
                İade & İptal
              </li>
            </ul>
          </div>

          {/* İletişim */}
          <div>
            <h4 className="text-lg font-semibold ">İletişim</h4>
            <hr className="border-b  border-yellow-500" />
            <div>
              <p className="text-sm text-white ">E-posta Adresi</p>
              <a
                href="mailto:classroom.destek@gmail.com"
                className="text-lg text-white hover:text-yellow-600 transition-colors"
              >
                classroom.destek@gmail.com
              </a>
            </div>
            <p className="text-sm text-white">Telefon Numarası</p>
            <a
              href="tel:05344550121"
              className="text-lg text-white hover:text-yellow-600 transition-colors"
            >
              0534 455 01 21
            </a>
            <p className="mt-1 text-sm ">
              © {new Date().getFullYear()} Classroom
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
